import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afb281ea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=afb281ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb281ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afb281ea')) {
      api.createRecord('afb281ea', component.options)
    } else {
      api.reload('afb281ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=afb281ea&scoped=true&", function () {
      api.rerender('afb281ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwImage/index.vue"
export default component.exports